import moment from 'moment'
// import * as XLSX from 'xlsx-js-style'
import { getIsErrorValue, buildExcelColumns, setExportExcelDefaultStyle, setExportExcelDefaultColWidths } from '@/pages/dashboard/utils/utils'

const match_type = {
  string: 's',
  number: 'n',
  boolean: 'b',
  date: 'd'
}
export async function exportExcel(fileName, table, heads = []) {
  fileName = fileName?.replace(/\u0020/g, '_')

  // 自定义单元格格式
  let data = exportExcel.formatData(table, heads)

  // 设置默认样式
  setExportExcelDefaultStyle(data)

  const XLSX = await import('xlsx-js-style');

  // 创建book
  let wb = XLSX.utils.book_new()

  // json转sheet
  let ws = XLSX.utils.json_to_sheet(data, { header: [], skipHeader: true })

  // 设置列宽
  setExportExcelDefaultColWidths(ws, data)

  // 下载时操作系统不允许输入半角冒号，所以用全角的代替
  let timestamp = moment().format('YYYY_MM_DD HH_mm_ss')

  // sheet写入book
  XLSX.utils.book_append_sheet(wb, ws, 'file')

  // 输出
  XLSX.writeFile(wb, `${fileName} ${timestamp}.xlsx`)
}

exportExcel.formatData = function (table, heads) {
  if (!heads.length) return table

  const data = []
  const letters = buildExcelColumns(heads?.length ?? 0) // 解决数字首位的列名乱序问题
  const row = heads?.reduce((o, { key, header, name }, i) => ((o[letters[i]] = header ?? name), o), {}) ?? {}
  Object.keys(row).length && data.push(row)

  for (let i = 0, l = table.length; i < l; i++) {
    let row = table[i]
    let newRow = {}

    heads?.forEach(({ key, type, format }, ii) => {
      let z = format || '' // 见 https://github.com/rockboom/SheetJS-docs-zh-CN 默认的数字格式
      let t = match_type[type] ?? 's' // 见 https://github.com/rockboom/SheetJS-docs-zh-CN 数据类型
      let v = row[key]

      if (z) {
        switch (t) {
          case 'n':
            newRow[letters[ii]] = { t: getIsErrorValue(v) ? 's' : t, v: getIsErrorValue(v) ? '-' : v, z }
            break
          case 'd':
            newRow[letters[ii]] = { t, v, z }
            break
          default:
            newRow[letters[ii]] = { v }
        }
      } else {
        newRow[letters[ii]] = { v }
      }
    })

    data.length && data.push(newRow)
  }

  return data
}
